export { CollapsibleArea } from './CollapsibleArea'
